module.exports = __webpack_public_path__ + "static/media/4-debasement.75f674f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/4-debasement.mp3
// module id = aUk6
// module chunks = 0